// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fnVY","expireSoon":"styles_expireSoon__BYvaM"};